<script>
import Chat from '@components/tabs/chat.vue'

export default {
  components: { Chat },
  methods: {},
}
</script>

<template>
  <Chat />
</template>

<style lang="scss" module>
@import '@design';
</style>
